import { MapView } from './map';
import { EventLocation, EventLocationSelector } from './geography';
import { initBootstrap } from './site';
import * as bootstrap from 'bootstrap';

import 'select2';




export interface Hotel {
    $id: number;// json reference id
    id: number;
    position: google.maps.LatLngLiteral;
    distance: number;
    stars: number;
    numberOfRooms: number;
    accommodationType: number;
    rating: number
}

export interface HotelsListResult {
    storageKey: string;
    center: google.maps.LatLngLiteral;
    hotels: Hotel[];
    optimalRadius: number;
}

export interface hotelsListOptions {
    selector: string;
    url: string;
    pageSize: number;
    locals: hotelsListResultLocals;
}

export interface hotelsListResultLocals {
    
    singleResult: string;
    multipleResult: string;
}


export interface hotelsMapOptions {
    selector: MapView | (() => MapView),
    infoWindow: string;
}

export interface HotelsListOptions {

    list: hotelsListOptions;
    map: hotelsMapOptions;
    filters: HotelsListFilters;    
}

export interface HotelsListFilters {
    rooms: string ;
    stars: string ;
    reviewScore: string;
}
//export interface Hotel {
//    id: string;
//    stars: number;
//    position: google.maps.LatLngLiteral;
//}

//export class HotelWithDistance
//{
//    public id: string;    
//    public stars: number;
//    public position: any;
//    public distance: any;
//}

export class ListView {

}

export interface HotelsController {
    searchAll(eventLocationGuid: string): Promise<Hotel[]>;
}

export class HotelsList {

    private _options: HotelsListOptions;
    private listPlaceHolder: JQuery;    
    static Instance: HotelsList;
    constructor(options: HotelsListOptions) {
        console.log('Hotels class object created');
        const instance = this;

        this._options = options;
        this.listPlaceHolder = $(options.list.selector).children().clone();
        this.location = EventLocationSelector.Instance;
         
        let lazyLoader: NodeJS.Timeout;
         
        $('#EventLocationGuid, #Radius, #SortExpression').on("change change-selection", function () {

            console.log("selecting");

            if (lazyLoader)
                clearTimeout(lazyLoader);

            lazyLoader = setTimeout( ()=>instance.filter(), 100);
        });


        $(document).on('change-selection', '#SortExpression', e => {
            console.log("selecting");

            if (lazyLoader)
                clearTimeout(lazyLoader);

            lazyLoader = setTimeout(() => instance.filter(), 100);
        });
        
        this.list.on("scroll", handleScroll);

        let isLoading = false;

        // Fonction pour détecter quand on approche du bas de la page
        const scrollContainer = document.querySelector(options.list.selector);
        function handleScroll(el) {

            const scrollPosition = scrollContainer.scrollTop + scrollContainer.clientHeight;
            const threshold = scrollContainer.scrollHeight - 200; // 200px avant la fin

            if (scrollPosition >= threshold && !isLoading) {

                var pageIndex = instance.pageIndex;
                const pageSize = instance.pageSize;//.data('page-size');// instance.pageSize;

                var hotels = instance.list.prop('Hotels');
                var ids = hotels.map(c => c.id);

                pageIndex++;
                instance.list.prop('PageIndex', pageIndex);

                var page = ids.slice(pageIndex * pageSize, pageSize + (pageIndex * pageSize));
                if (page.length > 0) {
                    isLoading = true;
                    $.post("/" + document.documentElement.lang + "/hotels/_ListPartial", { eventLocationGuid: instance.eventLocation.guid, radius: instance.radius, accommodations: page })
                        .done(function (data) {
                            instance.list.append($(data));
                            initBootstrap();
                        })
                        .fail(function (err) {                            
                            instance.list.append(`<div class='alert alert-danger text-center'>${JSON.stringify(err)}</div>`);
                        }).always(function () {
                            isLoading = false;
                        });
                }

            }
        }

        $('#view-map,#view-list,#view-combined').on('change', function () {
            instance.setView(this.id);
        });

        $('#rbCols2,#rbCols3').on('change', function () {
            if ((this as HTMLInputElement).checked) {
                instance.setColumns(this.id);
                instance.saveGroupState("rbCols", this.id);
            }
        });

        $(function () {
            instance.loadViewState();
            instance.switchMobileView();
        });

        window.addEventListener('resize', function () { instance.switchMobileView(); });

        HotelsList.Instance = this;
    }

    public location: EventLocationSelector;

    public get pageSize(): number {
        if (typeof this._options.list.pageSize == "number")
            return this._options.list.pageSize;
        if (typeof this._options.list.pageSize == "string")
            return Number(this._options.list.pageSize);

        return 15;
    }

    public get pageIndex(): number {
        return this.list.prop("PageIndex") ?? 0;
    }


    public get eventLocation(): EventLocation {
        return EventLocationSelector.Instance.selectedEventLocation;
    }
    public get radius(): number {
        return EventLocationSelector.Instance.radius;
    }

    public get list(): JQuery {
        return $(this._options.list.selector);
    }

    public get mapView(): MapView {
        return typeof this._options.map.selector == 'function' ? this._options.map.selector() : this._options.map.selector;
    }

    public filter() {
        //var list = options.list.listView();
        const instance = this;
        const options = this._options;

        console.log("Loading hotels");

        instance.list.empty().append($(instance.listPlaceHolder)).prop('PageIndex', 0);

        $('.map-loader, .list-loader').show();


        const eventLocation = instance.eventLocation;
        const radius = instance.radius;

        const rooms = $(this._options.filters.rooms).val();

        //    min: $('#rooms').val(),
        //    max:$('#rooms_to').val()
        //};
        const stars = {
            min: $(`${this._options.filters.stars}_from`).val(),
            max: $(`${this._options.filters.stars}_to`).val()
        }

        const ranking = {
            min: $(`${this._options.filters.reviewScore}_from`).val(),
            max: $(`${this._options.filters.reviewScore}_to`).val()
        }

        const sortExpression = $("#SortExpression").val();

        // update params in address bar. 

        let params = new URLSearchParams(window.location.search);
        params.set("rooms", rooms.toString());

        params.set("stars_from", stars.min.toString());
        params.set("stars_to", stars.max.toString());        
        //params.set("rooms_to", rooms.max.toString());
        params.set("ranking_from", ranking.min.toString());
        params.set("ranking_to", ranking.max.toString());

        params.set("listSort", sortExpression.toString());
         
        window.history.pushState('object or string', 'Title', "?" + params.toString());    

        instance.mapView.clear().lazyLoad().then(map => {

            map.clear().setCenter(eventLocation.position);


            map.addSimpleMarker({
                content: map.defaultMarker,
                title: eventLocation.name,
                position: eventLocation.position,
                contentUrl: '/Map/EventLocationPopup?id=' + eventLocation.guid,
                allowCluster: false
            });
        });


        $.post(options.list.url, { eventLocationGuid: eventLocation.guid, radius, rooms, stars, ranking, sortExpression })
            .done(function (data) {

                instance.list.prop('PageIndex', 0);
                instance.list.prop('Hotels', data.hotels);
                instance.list[0]?.scrollTo({ top: 0 });

                window.localStorage.removeItem("ListHotels");

                window.localStorage.setItem("ListHotels", JSON.stringify(data));

                instance.addToMap(data, options.map.infoWindow).then(() => {
                    $('.map-loader').hide();
                });;
                instance.addToList(data, options).then(() => {
                    $('.list-loader').hide();
                });


            })
            .fail(function (error) {
                $('.map-loader, .list-loader').hide();
                alert(error);
            });
    }

     

    public setColumns(rbCols: string) {
        if (rbCols == "rbCols2") {
            $("#col-map,#col-list").removeClass("col-md-4").removeClass('col-md-6').removeClass('col-md-8').removeClass('col-md-12').addClass('col-md-6');
            $("#col-list").show();
            $("#col-map").show();
        }
        if (rbCols == "rbCols3") {
            $("#col-map").removeClass('col-md-6').removeClass('col-md-12').addClass('col-md-4');
            $("#col-list").removeClass('col-md-6').removeClass('col-md-12').addClass('col-md-8');
            $("#col-list").show();
            $("#col-map").show();
        }

    }

    public setView(view :string) {

        if (view == "view-map") {
            $("#col-map").removeClass("col-md-4").removeClass('col-md-6').removeClass('col-md-8').addClass('col-md-12');
            $("#col-list").hide();
            $("#col-map").show();
            $('#rbCols2+label,#rbCols3+label').hide();

            this.mapView.lazyLoad().then((map) => map.fitBounds());
        }
        if (view == "view-list") {
            $("#col-list").removeClass("col-md-4").removeClass('col-md-6').removeClass('col-md-8').addClass('col-md-12');
            $("#col-map").hide();
            $("#col-list").show();
            $('#rbCols2+label,#rbCols3+label').hide();
        }
        if (view == "view-combined") {

            $('#rbCols2,#rbCols3').trigger('change');

            $("#col-map").show();
            $("#col-list").show();
            $('#rbCols2+label,#rbCols3+label').show();

            this.mapView.lazyLoad().then((map) => map.fitBounds());
        }
        this.saveGroupState("view", view);
    }

    public saveGroupState(group, value) {
        window.localStorage.setItem(group, value);
    }

    public loadViewState() {
        const rbCols = localStorage.getItem('rbCols');
        if (rbCols) {
            (document.getElementById(rbCols) as HTMLInputElement).checked = true;
            this.setColumns(rbCols);
        }

        const view = localStorage.getItem('view');
        if (view) {
            (document.getElementById(view) as HTMLInputElement).checked = true;
            this.setView(view);
        }
    }


    public switchMobileView() {
        const isMobile = window.innerWidth < 768; // Seuil mobile : 768px
        if (isMobile) {

            const input = document.querySelector('input[name=view]:checked') as HTMLInputElement;
            if (input.value === '3') { // si mode == combined
                // Sélectionner la vue Map
                const premierRadioGroupe1 = document.querySelector('input[name="view"]:first-of-type') as HTMLInputElement;
                if (premierRadioGroupe1) {
                    premierRadioGroupe1.checked = true;                    
                    this.setView(premierRadioGroupe1.id);
                }
            }
        }
    }



    public async addToMap(data: HotelsListResult, contentUrl: string): Promise<MapView> {
        return new Promise((resolve, reject) => {

            const mapView = this.mapView;

            var mapper = function (hotel: Hotel) {

                var div = document.createElement('div');
                div.className = 'hotel-marker stars-' + hotel.stars;
                //$(div).prop('stars', hotel.stars);

                return {
                    id: hotel.id,
                    position: hotel.position,
                    content: div,
                    contentUrl: contentUrl,
                    allowCluster: true
                };
            }

            var markers = data.hotels.map(mapper);
            mapView.addSimpleMarkers(markers).then(() => {

                mapView.fitBounds();
                resolve(mapView);
            });



        });



    }

    private currentPage: number;

    public async addToList(data: HotelsListResult, options: HotelsListOptions): Promise<HotelsList> {
        return new Promise<HotelsList>((resolve, reject) => {
            const _ = this;
            const list = this.list;
            const pageIndex = this.pageIndex;
            const pageSize = this.pageSize;

            var ids = data.hotels.map(c => c.id);
            $('#TotalRecord').text(ids.length +  " " + (ids.length > 1 ? options.list.locals.multipleResult : options.list.locals.singleResult));

            $.post("/" + document.documentElement.lang + "/hotels/_ListPartial", { eventLocationGuid: HotelsList.Instance.eventLocation.guid, radius: HotelsList.Instance.radius, accommodations: ids.slice(pageIndex * pageSize, pageSize) })
                .done(function (data) {
                    list.empty();
                    list[0]?.scrollTo({ top: 0 });
                    list.append($(data));
                    initBootstrap();
                    resolve(_)
                })
                .fail(function (err) {
                    reject(err);
                });
        });
    }
}


// Attache MapView à window
window.HotelsList = HotelsList;



export class HotelDetail {
    private _hotelId: number;
    constructor(hotelId: any) {
        this._hotelId = Number(hotelId);
    }

    public get items(): HotelsListResult | null {
        var item = window.localStorage.getItem("ListHotels");
        if (item == null)
            return null;

        var data = JSON.parse(item);
        return data as HotelsListResult;
    }

    public get itemIndex(): number {
        if (this.items != null) {
            return this.items.hotels.findIndex(h => h.id === this._hotelId);
        }
        return -1;
    }
    public get count(): number {
        if (this.items) {
            return this.items.hotels.length;
        }
        return 0;
    }

    public get prev(): number | null {

        if (this.itemIndex > 0) {
            var prevIndex = this.itemIndex - 1;
            while (!this.ping(this.items.hotels[prevIndex].id, "#prev-hotel-name") && prevIndex >= 0) {
                prevIndex--;
            }
            return Number(this.items.hotels[prevIndex].id);
        }

        return null;

    }
    public get next(): any | null {
        if (this.itemIndex != -1 && this.itemIndex < this.count) {

            var nextIndex = this.itemIndex + 1;

            while (nextIndex < this.count && !this.ping(this.items.hotels[nextIndex].id, "#next-hotel-name")) {
                nextIndex++;
            }
            if (nextIndex < this.count) {
                return Number(this.items.hotels[nextIndex].id);
            }
        }
        return null;
    }


    public ping(id: number, nameSelector:string): any {

        const pingResponse = $.ajax({
            url: "/hotels/ping", type: "POST", data: { id: id }, async: false
        });

        if (pingResponse.status == 200) {
            if (pingResponse.responseJSON.id === id) {                
                $(nameSelector).text(pingResponse.responseJSON.name);

                $(nameSelector).closest('button').attr('data-bs-title', pingResponse.responseJSON.name).tooltip("setContent");

                var $button = $(nameSelector).closest('button');
                $button.attr('data-bs-title', pingResponse.responseJSON.name);

                // Détruire la tooltip existante
                var tooltipInstance = bootstrap.Tooltip.getInstance($button[0]);
                if (tooltipInstance) {
                    tooltipInstance.dispose();
                }

                // Réinitialiser la tooltip
                $button.tooltip();

                
                return true;
            }
        }

        return false;

    }
}

(window as any).HotelDetail = HotelDetail;